var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.openHyperlink}},[_c('data-input',_vm._b({staticClass:"data-input-hyperlink",class:{ 'data-input-hyperlink-enabled': _vm.clickable },scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_c('v-icon',[_vm._v("mdi-web")])]},proxy:true}]),model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},'data-input',{
      isEditingOn: _vm.isEditingOn,
      ..._vm.$attrs,
      ..._vm.staticProps,
      rules: [...(_vm.$attrs.rules || []), v => !v || _vm.$_isValidUrl(v) || 'rules.notValidUrl'],
    },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }